import {
    Col,
    Row,
    Modal,
    Form,
    Input,
    Select,
    Button,
    TimePicker,
    InputNumber,
    Popconfirm,
    Tag,
    Spin,
} from "antd";
import { React, useEffect, useState } from "react";
import ButtonComp from "../../ButtonComp/ButtonComp";
import CustomTable from "../../Table/CustomTable";
import BasicFormItem from "../../BasicFormItem/BasicFormItem";
import { access_capabilities } from "../../../Utils/constants";
import "./LineSettingsProduct.css";
import { CheckCircleFilled, edit, trash, CloseCircleFilled } from "../../../Utils/imports";
import { LineSettingsShiftForm } from "../../../Utils/constants";
import { LineSettingsProductVar } from "../../../Utils/variables";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import SyncMachine from "../SyncMachine/SyncMachine";
import { CheckCircleOutlined } from "@ant-design/icons";
import { createProduct, deleteProduct, editProduct } from "../../../API-Interaction/apiServices/plantSettings.api";
import { antIcon, formatCapabilities, canPerformAction } from "../../../Helpers/helpers";

const { TextArea } = Input;
const {
    heading,
    add_product,
    name,
    sku,
    recipe,
} = LineSettingsProductVar;

const LineSettingsProduct = () => {
    const [form] = Form.useForm()
    const dispatch = useDispatch()
    const [selectedMachines, setState] = useState([]);
    const { current = null} = useSelector(state => state.plant)
    let productSettings  = current?.machine?.shifts || current?.line?.shifts || null
    let {plant = null, machine = null} = current;
    const { pageLoaders, componentLoaders } = useSelector(state => state.utils.loaders)

    const [productModal, setProductModal] = useState(false);
    const [doWhat, setDoWhat] = useState('create');
    const [switches] = useState({ status: false, medium: false });
    let options = [];

    const handleChange = (...params) => { 
        let [two] = params
        console.log(`${two}`);
    };

    const onFinish = async (values) => {
        console.log(values)
        if (doWhat === 'edit')
            await editProduct(dispatch, { values, rec: switches?.prevRec }, current)
        if (doWhat !== 'edit')
            await createProduct(dispatch, { ...values }, current)
        setDoWhat('create')
        setProductModal(false)
    };

    const onFinishFailed = (errorInfo) => {
        console.log("Failed:", errorInfo);
    };

    const handleEdit = (record) => {
        console.log({ record, product: record?.line?.shifts?.product.map((line) => ({ label: line?.shift?.product.name, value: line?.shift?.product.id })) })
        setDoWhat('edit')
        form.setFieldsValue({
            name: record?.name,
            sku: record?.sku,
            primary: record?.primary,
            secondary: record?.secondary,
            time: moment(record.time)
        })
        setProductModal(true)
    }

    const handleDelete = async (record) => {
        console.log(record)
        await deleteProduct(dispatch, { rec: record }, current)
    }
    const sync = async() => {
        // if((admin('product-access')))
        // {
        //   notification.error({
        //     message: 'Not have access to sync. ',
        //   });
        //   //this.handleCancel();
        //   return;
        // }
        //   try {
        //     await syncMachineShifts({plantId: current?.plant?._id, lineId: current?.line?.id, machines: selectedMachines, productionLine:{
        //       shifts:current?.shift?.name, 
        //       machines:current?.machine?.machines
        //     },machine})
        //     notification.success({
        //       message: 'Sync Successful',
        //     });
    
        //   }
        // catch(err) {
        //   console.log(err)
        //   notification.error({
        //     message: 'Sync Failed',
        //   });
        // }
    }
    const ProductModal = () => {

        return (
            <Modal
                title={<h2>{add_product}</h2>}
                centered
                open={productModal}
                maskClosable={false}
                onCancel={() => setProductModal(false)}
                footer={null}
                className="ProductModal"
            >
                <Spin indicator={antIcon} spinning={componentLoaders?.productModal || false} >
                <div>
                <Form
                        form={form}
                        name="lineShiftForm"
                        className="lineShiftForm"
                        labelCol={{
                            span: 8,
                        }}
                        wrapperCol={{
                            span: 24,
                        }}
                        initialValues={{
                            remember: false,
                        }}
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        autoComplete="off"
                    >
                        <h4>{name}</h4>
                        <Form.Item
                            name="name"
                            rules={[
                                {
                                    required: true,
                                    message: "Enter Name",
                                },
                            ]}
                        >
                            <Input className="boxBorderRad width100P" placeholder={"Add Name"} />
                        </Form.Item>
                        <h4>{sku}</h4>
                        <Form.Item
                            name="sku"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Enter SKU!",
                                },
                            ]}
                        >
                         <Input className="boxBorderRad width100P" placeholder={"Add SKU"} />
                        </Form.Item>
                        <Row gutter={6}>
                            <Col span={12}>
                                <h4>{recipe}</h4>
                                <Form.Item
                                    name="primary"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please select Primary!",
                                        },
                                    ]}
                                >
                                    <InputNumber className="boxBorderRad width100P" placeholder={"Primary"} type="number" />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                            <h4> </h4>
                                <Form.Item
                                    name="secondary"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please select Secondary!",
                                        },
                                    ]}
                                >
                                    <InputNumber className="boxBorderRad width100P" placeholder={"Secondary"} type="number" />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row className="dflex alignCenter justifyCenter gap10" >
                    <Form.Item>
                        <ButtonComp
                            style={{ width: "180px" }}
                            theme={"blue"}
                            htmlType="submit"
                            text={"Save"}
                            icon={<CheckCircleFilled />}
                        />
                    </Form.Item>
                    <Form.Item>
                        <ButtonComp
                            style={{ width: "180px" }}
                            theme={"red"}
                            text={"Cancel"}
                            icon={<CloseCircleFilled />}
                            onClick={() => setProductModal(false)}
                        />
                    </Form.Item>
                </Row>
                    </Form>
        </div>
                </Spin>
            </Modal >
        );
    };

    const LineSettingsProductTableColumns = [
        {
            title: "Name",
            dataIndex: "name",
            render: (text, record) =>  (
                <>
                {<div>{record?.product.name}</div>}
                </>
            )
        },
        {
            title: "Line Speed",
            dataIndex: "line speed",
            render: (text, record) =>(
                <>
            {
                <div>{record?.product.lineSpeed}</div>
            }
            </>
            )
        },
        {
            title: 'SKU',
            dataIndex: 'sku',
            render: (text, record) => (
                <>
                {<div>{record?.product.id}</div>}
                </>
            ),
        },
    ]
    // if (canPerformAction(current, access_capabilities.canEditLineSettings)) {
        LineSettingsProductTableColumns.push({
            title: 'Actions',
            dataIndex: 'actions',
            render: (key, rec) => (<div className='dflex alignCenter justifyCenter gap10'><img onClick={() => handleEdit(rec)} src={edit} className="cursorPointer" />
            <Popconfirm placement="topRight" okText="Delete" cancelText="Cancel" okButtonProps={{className: "popRed"}} cancelButtonProps={{className: "popBlue"}} title="Confirm delete ?" onConfirm={() => { handleDelete(rec) }}>
             <img src={trash} className="cursorPointer" />
            </Popconfirm>
             </div>
            ),
            align: "center"
        });
        // }

    return (
        <>
        <Row className="pt1">
            <Row className="width100P">
                <Col span={12}>
                    <h1 className="pageHead">{heading}</h1>
                </Col>
                {/* {canPerformAction(current, access_capabilities.canEditLineSettings) && ( */}
                <Col span={12} className="dflex justifyFE">
                    <ButtonComp
                        onClick={() => { form.resetFields(); setProductModal(true); }}
                        theme="blue"
                        text="Add Product"
                        img={"notification-bing"}
                    />{" "}
                    <ProductModal />
                </Col>
                {/* )} */}
            </Row>
            <Row className="width100P pt10 ">
                <Col span={24}>
                    <CustomTable
                        columns={LineSettingsProductTableColumns}
                        dataSource={productSettings}
                    />
                </Col>
            </Row>
        </Row>
        <Form>
            <SyncMachine
             machine={machine}
            //  canSync={(x) => canSync(x)}
             selectedMachines={selectedMachines}
             sync={sync}
             productionLine={current?.line?.productionLine}
             changeMachines = {(machines) => {setState(machines)}} />
        </Form>
      </>
    );
};

export default LineSettingsProduct;
